import MfaReminderModal from './MfaReminderModal';

export default MfaReminderModal;
